import { Store } from 'vuex';
import { IState } from '@app/store';
import SportOffer, { ISportOfferState } from './sportOffer/sportOfferIndex';
import Lotto, { subscriptions as lottoUISubscriptions } from './lotto/lottoPageIndex';
import Modal, { IModalState } from './shared/modal/modalIndex';
import { ILottoState } from '@store/modules/ui/lotto/types';
import Special, { ISpecialsState } from './specialOffer/specialPageIndex';
import DeviceInfo, { IDeviceInfoState } from './deviceInfo/deviceInfoIndex';
import TicketsStack, { ITicketsStackState } from './shared/ticketsStack/ticketsStackIndex';
import TicketsPage, { ITicketPageState } from './tickets';
import User, { IUserState, UIUserGetters } from '@store/modules/ui/user/userIndex';
import Help, { IHelpState } from '@store/modules/ui/help/helpIndex';
import Results from './results';
import Mobile, { IUIMobileState } from './mobile/mobileIndex';

export function subscriptions(store: Store<IState>, publicActions: any) {
    lottoUISubscriptions(store, {
        lottoEventsSetter: publicActions.SET_LOTTO_EVENTS,
    });
}

export interface IUiState {
    sportOffer: ISportOfferState;
    lotto: ILottoState;
    modal: IModalState;
    ticketsStack: ITicketsStackState;
    user: IUserState;
    deviceInfo: IDeviceInfoState;
    help: IHelpState;
    special: ISpecialsState;
    ticketsPage: ITicketPageState;
    mobile: IUIMobileState;
}

export interface UIGetters {
    user: UIUserGetters;
}

export default {
    namespaced: true,
    modules: {
        sportOffer: SportOffer,
        lotto: Lotto,
        modal: Modal,
        special: Special,
        ticketsStack: TicketsStack,
        user: User,
        deviceInfo: DeviceInfo,
        help: Help,
        ticketsPage: TicketsPage,
        results: Results,
        mobile: Mobile,
    },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/uiIndex.ts